'use client'

export const getSectionLink = (url) => {
  let pathname
  try {
    const urlObj = new URL(url)
    pathname = urlObj.pathname
  } catch (e) {
    pathname = url
  }

  // Limpiar barras iniciales y finales
  pathname = pathname.trim()
  if (pathname.length > 0) {
    if (pathname.startsWith('/')) {
      pathname = pathname.substring(1)
    }
    if (pathname.endsWith('/')) {
      pathname = pathname.slice(0, -1)
    }
  }
  const segments = pathname.split('/').slice(1)

  if (segments.length >= 2) {
    const restOfSegments = segments.slice(1).join(':')
    return `${segments[0]}:${restOfSegments}`
  }

  if (segments.length === 1 && segments[0] !== '') {
    return `home:${segments[0]}`
  }

  return 'home'
}
